import request from '@/api/request'
import store from '@/store'

export function vehicleMonitorTestVinStateByExtId(extId) {
  return request({
    url: '/vehicleMonitor/extId/testVinState/' + extId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorSearchByExtId(testFlag, extId) {
  let url = '/vehicleMonitor/extId/metrics/'
  if (testFlag) {
    url = '/vehicleMonitor/extId/testVinMetrics/'
  }
  return request({
    url: url + extId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorUnregisterExtId(extId) {
  return request({
    url: '/vehicleMonitor/extId/unregisterODP/' + extId,
    method: 'delete',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorTransactionState(transactionId) {
  return request({
    url: '/vehicleMonitor/transactionState/' + transactionId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function vehicleMonitorSendPayloadCallbackByExtId(extId, data) {
  return request({
    url: '/vehicleMonitor/extId/clmCallback/' + extId,
    method: 'post',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    },
    data: data
  })
}

export function vehicleMonitorSopAddByExtId(data) {
  return request({
    url: '/vehicleMonitor/extId/sop/add',
    method: 'post',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    },
    data: data
  })
}

export function vehicleMonitorSopDeleteByExtId(data) {
  return request({
    url: '/vehicleMonitor/extId/sop/delete',
    method: 'delete',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    },
    data: data
  })
}

export function triggerPurchaseByExtId(extId, transactionId) {
  return request({
    url: '/vehicleMonitor/extId/trigger/purchase/' + extId + '/' + transactionId,
    method: 'put',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function checkTransactionStateByExtId(extId, transactionId) {
  return request({
    url: '/vehicleMonitor/extId/check/transactionstate/' + extId + '/' + transactionId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function articlesCapabilityByExtId(extId) {
  return request({
    url: '/vehicleMonitor/extId/articlesCapability/' + extId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

export function extIdValidate(extId) {
  return request({
    url: '/extIdValidate/' + extId,
    method: 'get',
    headers: {
      'X-Brand': store.getters.brand,
      'X-Region': store.getters.region
    }
  })
}

